import script from "./IconRemove.vue?vue&type=script&setup=true&lang=js"
export * from "./IconRemove.vue?vue&type=script&setup=true&lang=js"

import "./IconRemove.vue?vue&type=style&index=0&id=ec28cf12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec28cf12"]])

export default __exports__